const Theme = {
  primary: "#0084ff",
  secondary: "#3a58ff",
  black: "#000000",
  dark: "#1f1f1f",
  white: "#f8f7f7",
}

export default Theme
